import { Box, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import React from "react";

import CustomLink from "components/Chakra/CustomLink";

export const FAQS = [
  {
    title: "Kolik prověření stojí?",
    text: (
      <Box>
        <Text>
          Od <b>149&nbsp;Kč</b> vám ušetříme hodiny manuálního hledání na
          různých veřejnosprávních portálech. Tato částka zahrnuje
          i&nbsp;přístupy do placených databází. Instantně prověříme až
          15&nbsp;nejdůležitějších databází a&nbsp;výsledek obdržíte
          v&nbsp;přehledném reportu.
        </Text>
      </Box>
    ),
  },

  {
    title: "Jak vypadá výsledek prověření?",
    text: (
      <Box>
        <Text>
          Výsledek pátraní vám obratem sepíšu do přehledného reportu,{" "}
          <b>včetně odkazů na detailní záznamy</b> v&nbsp;prověřovaných
          databázích. Report si můžete vytisknout nebo ho komukoliv rychle
          poslat.
        </Text>
      </Box>
    ),
  },
  {
    title: "Které rejstříky se prověřují?",
    text: (
      <>
        <Box pl="20px">
          <Text as="h3" variant="h4" fontWeight="bold" pb={2}>
            České rejstříky:
          </Text>
          <UnorderedList>
            <ListItem>Centrální evidence exekucí ČR (CEE)</ListItem>
            <ListItem>Insolvenční rejstřík</ListItem>
            <ListItem>Hledané osoby Policií ČR</ListItem>
            <ListItem>Obchodní rejstřík</ListItem>
            <ListItem>Registr živnostenského podnikání</ListItem>
            <ListItem>Trvalá adresa na úřadě</ListItem>
          </UnorderedList>
        </Box>
        <Box pt={4} pl="20px">
          <Text as="h3" variant="h4" fontWeight="bold" pb={2}>
            Slovenské rejstříky:
          </Text>
          <UnorderedList>
            <ListItem>Registr dlužníků na Slovensku</ListItem>
            <ListItem>Slovenská komora exekutorů</ListItem>
            <ListItem>Osoby hledané Policií SR</ListItem>
            <ListItem>Finanční správa</ListItem>
            <ListItem>Union zdravotní pojišťovna</ListItem>
            <ListItem>Všeobecná zdravotní pojišťovna</ListItem>
            <ListItem>Dovera zdravotní pojišťovna</ListItem>
            <ListItem>Obchodní registr</ListItem>
            <ListItem>Živnostenský register</ListItem>
          </UnorderedList>
        </Box>
        <Box pt={4} pl="20px">
          A osobu pro vás najdeme i&nbsp;na sociálních sítích.
        </Box>
      </>
    ),
  },
  {
    title: "Proč bych měl prověřovat s vámi?",
    text: (
      <Box>
        <Text>
          <b>Ušetříme vám čas, starosti a&nbsp;nemilá překvapení.</b> Osoby
          prověřujeme důkladně a&nbsp;ve všech důležitých registrech – jak
          v&nbsp;Česku tak na Slovensku. Výsledek prověření obdržíte obratem
          v&nbsp;uceleném PDF reportu, včetně odkazů na detailní záznamy
          v&nbsp;prověřovaných databázích. Ušetříme vám tak několik hodin
          manuálního hledání napříč několika veřejnosprávními portály
          a&nbsp;rejstříky.
        </Text>
      </Box>
    ),
  },
  {
    title: "Co když zadám nějaký údaj špatně?",
    text: (
      <Box>
        <Text>
          Dávejte si prosím pozor a&nbsp;vždy zkontrolujte, že údaje, které jste
          do formuláře zadali, jsou{" "}
          <b>přesné a&nbsp;správné včetně diakritiky</b>. Pokud je jméno
          prověřované osoby například Jan Müller, nestačí napsat Jan Muller –
          v&nbsp;tomto případě by se nalezený záznam mohl týkat úplně jiné
          osoby.
        </Text>
      </Box>
    ),
  },
  {
    title: "Je prověření osoby legální?",
    text: (
      <Box>
        <Text>
          <b>Ano, zcela</b>. V rámci procesu prověření nahlížíme do veřejně
          přístupných databází a&nbsp;rejstříků. Informace, které tam objevíme,
          pro vás poskládáme do přehledného PDF reportu, včetně odkazů na
          detailní záznamy v&nbsp;prověřovaných databázích.
        </Text>
      </Box>
    ),
  },
  {
    title: "Chci prověřit větší množství osob, jde to?",
    text: (
      <Box>
        <Text>
          <b>Určitě</b>. Pokud máte zájem o&nbsp;prověření většího množství
          osob, nabízíme{" "}
          <CustomLink to="/balicky-provereni" showUnderline>
            zvýhodněné balíčky prověření rizikovosti.
          </CustomLink>
        </Text>
      </Box>
    ),
  },
  {
    title: "Jak dlouho mám přístup k výsledkům prověření?",
    text: (
      <Box>
        <Text>
          <b>Napořád.</b> Hned po zaplacení se vám zobrazí kompletní report,
          který si můžete stáhnout ve formátu PDF. Je však důležité si uvědomit,
          že uvedené výsledky jsou platné <b>v den vypracování prověření</b> –
          pokud se někdo dostane do potíží o&nbsp;pár týdnů či měsíců později,
          v&nbsp;dnešním reportu se to samozřejmě ještě nemůže objevit.
        </Text>
      </Box>
    ),
  },
  {
    title: "Jsou výsledky aktuální a spolehlivé?",
    text: (
      <Box>
        <Text mb="10px">
          Ano. Rejstříky prověřuji v&nbsp;momentě, kdy odešlete formulář –
          garantujeme vám tedy, že uvedené výsledky jsou{" "}
          <b>platné v&nbsp;den vypracování prověření</b>. Pokud však někdo
          přijde k&nbsp;exekuci nebo se dostane do křížku se zákonem o&nbsp;pár
          týdnů či měsíců později, v&nbsp;dnešním reportu se to samozřejmě ještě
          nemůže objevit.
        </Text>
        <Text>
          Jedna poznámka na závěr: Může se stát, že na základě vámi vyplněných
          údajů dojde k vyhledání více osob, které mají zcela shodné jméno,
          příjmení i&nbsp;datum narození – tato situace je statisticky velmi
          neobvyklá, ale nelze ji úplně vyloučit. V&nbsp;takovém případě bohužel
          nemůžeme nést odpovědnost za rozlišení těchto výsledků.
        </Text>
      </Box>
    ),
  },
];

export const CCS = [
  {
    title: "Insolvenční rejstřík",
    text: (
      <Box>
        <Text>
          Zaznamenává všechna probíhající i&nbsp;ukončená a&nbsp;dosud
          nevymazaná insolvenční řízení. Obsahuje seznam dlužníků
          a&nbsp;insolvenční spisy u&nbsp;jednotlivých řízení.
        </Text>
      </Box>
    ),
  },
  {
    title: "Registr živnostenského podnikání",
    text: (
      <Box>
        <Text>
          Slouží k&nbsp;vyhledávání podnikatelských subjektů ve veřejné části
          živnostenského rejstříku a&nbsp;získání aktuálních a&nbsp;historických
          údajů o&nbsp;podnikatelských subjektech.
        </Text>
      </Box>
    ),
  },
  {
    title: "Trvalá adresa na úřadě",
    text: (
      <Box>
        <Text>
          Osoby s&nbsp;adresou na úřadě se nejčastěji nacházejí v&nbsp;tíživé
          sociální situaci nebo jsou odhlášení z&nbsp;jiné adresy z&nbsp;důvodu
          exekuce, proto vám adresu kontroluje v&nbsp;databázi územních
          samospráv.
        </Text>
      </Box>
    ),
  },
  {
    title: "Vyhledání sociálních sítí",
    text: (
      <Box>
        <Text>
          Informace na sociálních sítích vám o&nbsp;zájemci může vypovědět
          mnoho. Dle jména vám najdeme účet na Facebooku, kde si zájemce můžete
          prohlédnout.
        </Text>
      </Box>
    ),
  },
  {
    title: "Centrální evidence exekucí",
    text: (
      <Box>
        <Text>
          Jde o&nbsp;veřejný seznam, který je veden, provozován a&nbsp;spravován
          Exekutorskou komorou České republiky. Na konci roku 2021 evidovala
          komora na 698 028 lidí v exekucí, kdy v&nbsp;průměru mají dlužníci
          šest exekucí.
        </Text>
      </Box>
    ),
  },
  {
    title: "Osoby hledané Policií ČR",
    text: (
      <Box>
        <Text>
          Přehled všech pohřešovaných a&nbsp;hledaných osob, po kterých Policie
          České republiky vyhlásila pátrání, ať už v&nbsp;současnosti nebo
          v&nbsp;minulosti.
        </Text>
      </Box>
    ),
  },
  {
    title: "Informace z obchodního rejstříku",
    text: (
      <Box>
        <Text>
          Rejstřík ukazuje užitečné informace o&nbsp;konkrétních obchodních
          společnostech či podnikatelích. Zjistíte, zda zájemce podniká, není-li
          majitelem firmy, nebo v&nbsp;jakém oboru působí.
        </Text>
      </Box>
    ),
  },
  {
    title: "Registr dlužníků",
    text: (
      <Box>
        <Text>
          Záznamy uchovávané slovenským registrem dlužníků vznikají kombinací
          dat z&nbsp;informačních systémů soudů, Obchodního věstníku
          a&nbsp;Registru správců, od 31.&nbsp;7.&nbsp;2009.
        </Text>
      </Box>
    ),
  },
  {
    title: "Registr živnostenského podnikání",
    text: (
      <Box>
        <Text>
          Slouží k&nbsp;vyhledávání podnikatelských subjektů ve veřejné části
          živnostenského rejstříku vedeném v&nbsp;Slovenské republice.
        </Text>
      </Box>
    ),
  },
  {
    title: "Vyhledání sociálních sítí",
    text: (
      <Box>
        <Text>
          Informace na sociálních sítí vám o&nbsp;zájemci může vypovědět mnoho.
          Dle jména vám najdeme účet na Facebooku, kde si zájemce můžete
          prohlédnout.
        </Text>
      </Box>
    ),
  },
  {
    title: "Slovenská komora exekutorů",
    text: (
      <Box>
        <Text>
          Seznam všech neukončených exekucí spravuje Centrální registr exekucí
          Slovenské republiky. Kdy na začátku roku 2019 bylo v&nbsp;exekuci přes
          400&nbsp;tisíc domácností a&nbsp;od toho roku trend stoupá.
        </Text>
      </Box>
    ),
  },
  {
    title: "Osoby hledané policií SR",
    text: (
      <Box>
        <Text>
          Seznam pohřešovaných a&nbsp;hledaných osob, po kterých Policie
          Slovenské republiky vyhlásila pátrání, ať už v současnosti nebo
          v&nbsp;minulosti.
        </Text>
      </Box>
    ),
  },
  {
    title: "Finanční správa",
    text: (
      <Box>
        <Text>
          Seznam daňových dlužníků obsahuje informace evidované daňovými
          a&nbsp;celními úřady. Ukazuje jak daňové dlužníky, i&nbsp;osoby
          s&nbsp;nedoplatky.
        </Text>
      </Box>
    ),
  },
  {
    title: "Union zdravotní pojišťovna",
    text: (
      <Box>
        <Text>
          Veřejně přístupný přehled všech dlužníků zdravotní pojišťovny Union,
          kteří přesáhli celkovou sumu pohledávky či nedoplatku na více než
          100&nbsp;eur.
        </Text>
      </Box>
    ),
  },
  {
    title: "Všeobecná zdravotní pojišťovna",
    text: (
      <Box>
        <Text>
          Veřejně přístupný přehled všech dlužníků Všeobecné zdravotní
          pojišťovny, kteří přesáhli celkovou sumu pohledávky či nedoplatku na
          více než 100&nbsp;eur.
        </Text>
      </Box>
    ),
  },
  {
    title: "Dovera zdravotní pojišťovna",
    text: (
      <Box>
        <Text>
          Veřejně přístupný přehled všech dlužníků zdravotní pojišťovny Dovera,
          kteří přesáhli celkovou sumu pohledávky či nedoplatku na více než
          100&nbsp;eur.
        </Text>
      </Box>
    ),
  },
  {
    title: "Obchodní registr",
    text: (
      <Box>
        <Text>
          V registru se nachází všechny fyzické osoby s&nbsp;trvalou adresou na
          území Slovenské republiky, které podnikají, nebo mají podnikání
          hlášeno na Slovensku. Krom základních údajů registr vypisuje
          i&nbsp;vstup společností do likvidace.
        </Text>
      </Box>
    ),
  },
];
